<template>
  <div 
    class="fill-height mt-2">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>

            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
          <v-dialog v-model="dialog.confirm"
            @keydown.esc="dialog.confirm = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Konfirmasi Update Status

                <v-spacer/>

                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.confirm = false; dialog.fullscreen = false; selected.confirm = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin ingin mengubah status menjadi {{ selected.status }}?
              </v-card-text>

              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>

              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="pa-4">
                <v-spacer/>

                <v-btn
                  rounded
                  width="120"
                  @click="statuses()"
                  :loading="process.status"
                  :disabled="process.status"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Ubah
                </v-btn>

                <v-btn
                  rounded
                  width="120"
                  @click="dialog.confirm = false; dialog.fullscreen = false; selected.confirm = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-card 
            flat
            style="border-radius: 10px;">
            <v-card-text class="pa-1">
              <v-row
                class="pa-4 pb-1">
                <v-col 
                  cols="12"
                  class="py-0">
                  <v-card 
                    flat
                    height="calc(100vh - 255px)"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <ValidationObserver 
                        ref="form">
                        <v-form>
                          <v-row>
                            <v-col cols="6" class="py-0">
                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Nomor Surat Perintah
                                </div>
                                {{ form.spk_number }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  name="Nomor Surat Perintah" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Nomor Surat Perintah
                                  </div>
              
                                  <v-text-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
              
                                    :color="set_color"
                                    placeholder="Nomor Surat Perintah"
              
                                    hide-details
              
                                    v-model="form.spk_number"
                                    :success="form.spk_number !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.spk_number !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>
                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Tanggal surat perintah
                                </div>
                                {{ form.spk_date | date }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  name="Tanggal surat perintah" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Tanggal surat perintah
                                  </div>
              
                                  <v-text-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
              
                                    :color="set_color"
                                    placeholder="Tanggal surat perintah"
              
                                    hide-details
                                    type="date"
              
                                    v-model="form.spk_date"
                                    :success="form.spk_date !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.spk_date !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>

                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Nilai RAB
                                </div>
                                {{ form.rab_value }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  name="Nilai RAB" 
                                  rules="required|min_value:0" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Nilai RAB
                                  </div>
              
                                  <v-currency-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
              
                                    :color="set_color"
                                    placeholder="Nilai RAB"
              
                                    hide-details
              
                                    v-model="form.rab_value"
                                    :success="form.rab_value !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.rab_value !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-currency-field>
                                </ValidationProvider>
                              </div>

                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Nilai Kontrak
                                </div>
                                {{ form.contract_value | price }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  name="Nilai Kontrak" 
                                  rules="required|min_value:0" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Nilai Kontrak
                                  </div>
              
                                  <v-currency-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
              
                                    :color="set_color"
                                    placeholder="Nilai Kontrak"
              
                                    hide-details
              
                                    v-model="form.contract_value"
                                    :success="form.contract_value !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.contract_value !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-currency-field>
                                </ValidationProvider>
                              </div>

                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Penanggung Jawab
                                </div>
                                {{ form.pj_implementation }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  name="Penanggung Jawab" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Penanggung Jawab
                                  </div>
              
                                  <v-text-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
              
                                    :color="set_color"
                                    placeholder="Penanggung Jawab"
              
                                    hide-details
              
                                    v-model="form.pj_implementation"
                                    :success="form.pj_implementation !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.pj_implementation !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>
                            </v-col>
                            <v-col cols="6" class="py-0">
                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Tanggal Mulai (Durasi Project: {{ detail_project.duration }} {{ detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' }})
                                </div>
                                {{ form.start_date | date }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  name="Tanggal Mulai" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Tanggal Mulai (Rencana Pelaksanaan Project: {{ detail_project.duration }} {{ detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' }})
                                  </div>
              
                                  <v-text-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
              
                                    :color="set_color"
                                    @input="getWeekNumber()"
                                    placeholder="Tanggal Mulai"
              
                                    hide-details
                                    type="date"
              
                                    v-model="form.start_date"
                                    :success="form.start_date !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.start_date !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>

                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Tanggal Selesai
                                </div>
                                {{ form.end_date | date }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  name="Tanggal Selesai" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Tanggal Selesai
                                  </div>
              
                                  <v-text-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    @input="getWeekNumberEnd()"

                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
              
                                    :color="set_color"
                                    placeholder="Tanggal Selesai"
              
                                    hide-details
                                    type="date"
              
                                    v-model="form.end_date"
                                    :success="form.end_date !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.end_date !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>

                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Waktu Libur ({{ detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' }} Ke - )
                                </div>
                                {{ form.start_date }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  :name="`Waktu Libur (${detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu'} Ke - )`" 
                                  :rules="``" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <!-- <span class="red--text">*</span> -->
              
                                    Waktu Libur 
                                  </div>

                                  <v-row>
                                    <v-col cols="12" md="6">
                                      <v-card flat style="display: inline-block; border: 1px solid #f0f0f0;" class="mb-2">
                                        <v-date-picker
                                          v-model="form.holiday_array"
                                          scrollable
                                          multiple
                                          :min="form.start_date"
                                          :max="form.end_date"
                                          no-title
                                          color="red"
                                        >
                                        </v-date-picker>
                                      </v-card>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                      <div v-if="form.holiday_array.length > 0" class="d-flex flex-wrap">
                                        <div v-for="(item, index) in form.holiday_array" :key="index">
                                          <v-chip
                                            class="ma-1 white--text"
                                            color="green"
                                            close
                                            @click:close="form.holiday_array.splice(index, 1)">
                                            {{ item | date }}
                                          </v-chip>
                                          <!-- <v-card flat style="display: inline-block; border: 1px solid #f0f0f0;" class="mb-2">
                                            <v-card-text>
                                              <v-row>
                                                <v-col cols="12" class="py-0">
                                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                                    Waktu Libur Ke - {{ index + 1 }}
                                                  </div>
                                                  {{ item }}
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                          </v-card> -->
                                        </div>
                                      </div>
                                    </v-col>
                                  </v-row>



                                </ValidationProvider>
                              </div>
                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Durasi
                                </div>
                                {{ form.duration }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <ValidationProvider 
                                  name="Durasi Minggu" 
                                  rules="required|min_value:1" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Durasi Minggu
                                  </div>
              
                                  <v-currency-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="true"
              
                                    :color="set_color"
                                    placeholder="Durasi Minggu"
                                    suffix=" Minggu"
              
                                    hide-details
              
                                    v-model="form.weeks"
                                    :success="form.weeks !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.weeks !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-currency-field>
                                </ValidationProvider>

                                <ValidationProvider 
                                  name="Durasi Hari" 
                                  rules="required|min_value:1" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Durasi Hari
                                  </div>
              
                                  <v-currency-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="true"
              
                                    :color="set_color"
                                    placeholder="Durasi Hari"
                                    suffix=" Hari"
              
                                    hide-details
              
                                    v-model="form.duration"
                                    :success="form.duration !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.duration !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-currency-field>
                                </ValidationProvider>
                              </div>
                            </v-col>
                            
                            <v-col cols="12" class="pt-0">
                              <div class="mb-0 font_weight_600 fs-14 black_one mb-2">
                                Dokumen Kontrak
                              </div> 
                              <div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                <div class="mr-3">
                                  <uploadimage
                                    v-model="upload.image" >
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-btn
                                        color="#4B4B4B"
                                        elevation="0"
                                        small
                                        :disabled="process.image || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
                                        :loading="process.image"
                                        min-height="30"
                                        class="fs-12 white--text text-capitalize d-flex align-center"
                                        style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                        <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                        
                                        <span
                                          class="ml-2 ">
                                          Tambah Gambar
                                        </span>
                                      </v-btn>
                                    </div>
                                  </uploadimage>
                                </div>
                                <div class="mr-3">
                                  <uploadfile
                                    v-model="upload.document" >
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-btn
                                        color="primary"
                                        elevation="0"
                                        small
                                        :disabled="process.document || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
                                        :loading="process.document"
                                        min-height="30"
                                        class="fs-12 white--text text-capitalize d-flex align-center"
                                        style="border-radius: 6px; font-weight: 600;">
                                        <v-icon size="15">mdi-file-document</v-icon>
                                        
                                        <span
                                          class="ml-2 ">
                                          Tambah File
                                        </span>
                                      </v-btn>
                                    </div>
                                  </uploadfile>
                                </div>
                              </div>
  
                              <div class="">
                                <table style="border: 1px solid #ededed; width: 100%;">
                                  <tr>
                                    <th v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      Aksi
                                    </th>
                                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      Link
                                    </th>
                                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      Nama Dokumen Kontrak
                                    </th>
                                  </tr>
                                  <!-- <tr v-for="(item, index) in form.request_image" :key="index">
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="form.request_image.splice(index, 1)"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="indigo"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-image-area</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Lihat</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      <ValidationProvider 
                                        :name="`Nama Dokumen ${index + 1}`" 
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                                        <div class="mb-2 font_weight_600 fs-13 black_one">
                                          <span class="red--text">*</span>
                    
                                          Nama Dokumen
                                        </div>
                    
                                        <v-text-field
                                          v-on:keydown.enter.prevent="save()"
                                          
                                          filled
                                          rounded
                                          dense
                    
                                          :color="set_color"
                                          placeholder="Nama Dokumen"
                    
                                          hide-details
                    
                                          v-model="item.title"
                                          :success="item.title !== '' && valid"
                                          :error-messages="errors"
                                          required
                                          class="mb-0"
                                          style="border-radius: 10px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                    
                                            <div v-if="item.title !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-text-field>
                                      </ValidationProvider>
                                    </td>
                                  </tr>
                                  <tr v-for="(item, index) in form.request_file" :key="index">
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="form.request_file.splice(index, 1)"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            :color="item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">{{ item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Lihat</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      <ValidationProvider 
                                        :name="`Nama Dokumen ${index + 1}`" 
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                                        <div class="mb-2 font_weight_600 fs-13 black_one">
                                          <span class="red--text">*</span>
                    
                                          Nama Dokumen
                                        </div>
                    
                                        <v-text-field
                                          v-on:keydown.enter.prevent="save()"
                                          
                                          filled
                                          rounded
                                          dense
                    
                                          :color="set_color"
                                          placeholder="Nama Dokumen"
                    
                                          hide-details
                    
                                          v-model="item.title"
                                          :success="item.title !== '' && valid"
                                          :error-messages="errors"
                                          required
                                          class="mb-0"
                                          style="border-radius: 10px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                    
                                            <div v-if="item.title !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-text-field>
                                      </ValidationProvider>
                                    </td>
                                  </tr> -->
  
                                  <tr v-for="(item, index) in all_document" :key="index">
                                    <td v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="all_document.splice(index, 1)"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            :disabled="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Lihat</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true">
                                        {{ item.title }}
                                      </div>
                                      <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                                        <ValidationProvider 
                                          :name="`Nama Dokumen Kontrak ${index + 1}`" 
                                          rules="required" 
                                          v-slot="{ errors, valid }">
                                          <div class="mb-2 font_weight_600 fs-13 black_one">
                                            <span class="red--text">*</span>
                      
                                            Nama Dokumen Kontrak
                                          </div>
                      
                                          <v-text-field
                                            v-on:keydown.enter.prevent="save()"
                                            
                                            filled
                                            rounded
                                            dense
                                            :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
                      
                                            :color="set_color"
                                            placeholder="Nama Dokumen Kontrak"
                      
                                            hide-details
                      
                                            v-model="item.title"
                                            :success="item.title !== '' && valid"
                                            :error-messages="errors"
                                            required
                                            class="mb-0"
                                            style="border-radius: 10px;">
                                            <template v-slot:append-outer>
                                              <div v-if="errors.length > 0">
                                                <v-tooltip top color="#ff5252">
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                  </template>
                                                  
                                                  {{ errors[0] }}
                                                </v-tooltip>
                                              </div>
                      
                                              <div v-if="item.title !== '' && valid">
                                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                                              </div>
                                            </template>
                                          </v-text-field>
                                        </ValidationProvider>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
  
                              <v-card-text
                                v-if="all_document.length === 0"
                                class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                                <div class="text-center">
                                  <div class="mt-3 fs-16">
                                    Belum ada data Data Dokumen Kontrak
                                  </div>
                                </div>
                              </v-card-text>
  
                            </v-col> 
                          </v-row>
                        </v-form>
                      </ValidationObserver>
  
  
                      <div v-if="message.error.length > 0"
                        class="text-left d-flex align-center mr-3">
                        <div
                          class="error--text">
                          <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                          
                          <span
                            class="ml-1">
                            {{ message.error }}
                          </span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
  
              <v-row
                justify="end"
                :class="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? 'pa-5' : 'pa-4 py-0' : 'pa-5'">
                <v-col 
                  cols="12"
                  md="8">
                  <!-- <v-btn
                    @click="selected.status = 'Persiapan'; dialog.confirm = true"
                    :disabled="process.status || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
                    elevation="0"
                    rounded
                    v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false"
                    style="border-radius: 6px; font-weight: 600;"
                    color="#FFA000"
                    class="fs-14 white--text text-capitalize">
                    <v-icon
                      size="20">
                      mdi-update
                    </v-icon>
  
                    <span
                      class="ml-2">
                      Update ke Persiapan
                    </span>
                  </v-btn>
                  <v-btn
                    @click="selected.status = 'Negosiasi'; dialog.confirm = true"
                    :disabled="process.status || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
                    elevation="0"
                    rounded
                    v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false"
                    style="border-radius: 6px; font-weight: 600;"
                    color="indigo"
                    class="fs-14 white--text text-capitalize ml-2">
                    <v-icon
                      size="20">
                      mdi-update
                    </v-icon>
                    v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false"
  
                    <span
                      class="ml-2">
                      Update ke Negosiasi
                    </span>
                  </v-btn> -->
                </v-col>
                <v-col 
                  cols="12"
                  md="4"
                  class="d-flex align-center justify-end py-0">
                  <v-btn
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
                    elevation="0"
                    rounded
                    style="border-radius: 6px; font-weight: 600;"
                    color="success"
                    class="fs-14 white--text text-capitalize">
                    <v-icon
                      size="20">
                      mdi-checkbox-marked-circle-outline
                    </v-icon>
  
                    <span
                      class="ml-2">
                      Simpan
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        unit: [],
        detail_project: {},
        dialog: {
          snackbar: false,
          confirm: false,
          fullscreen: false
        },
        menu: false,
        form: {
          id: '',
          spk_number: '',
          spk_date: '',
          request_file_object: [],
          request_file: [],
          request_image: [],
          type_file: 'image',
          duration: '',
          rab_value: '',
          contract_value: '',
          pj_implementation: '',
          start_date: '',
          end_date: '',
          holiday_array: [],
          weeks: ''
        },
        weeks_count: 0,
        days_count: 0,
        filename: [],
        upload: {
          image: null,
          document: null
        },
        count_week: [],
        selected: {
          status: '',
          confirm: [],
          delete: []
        },
        all_document: [],
        client: [],
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,
          status: false,
          image: false,
          document: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploadfile: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            // this.form.request_file_object.type = 'image'
            this.message.error = ''
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.request_image.push({
                title: '',
                url: this.upload.image.fileuri,
                type: 'image'
              })
              this.all_document.push({
                title: '',
                url: this.upload.image.fileuri,
                type: 'image'
              })

              this.upload.image = null

              // this.form.request_file_object.url = this.upload.image.fileuri
            }
          }
        },
        deep: true
      },
      'upload.document': {
        handler: function () {
          if (this.upload.document) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.document = this.upload.document.process
            
            if (!this.process.document) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.document.fileuri.match(regexp);
              // CALLBACK FROM UPLOAD IMAGE
              this.filename.push(this.upload.document.filename)
              this.form.request_file.push({
                title: '',
                url: this.upload.document.fileuri,
                type: extension && extension[1]
              })
              this.all_document.push({
                title: '',
                url: this.upload.document.fileuri,
                type: extension && extension[1]
              })

              this.upload.document = null

              // this.form.request_file_object.url = this.upload.document.fileuri
            }
          }
        },
        deep: true
      },
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get(`project/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail_project = res.results.data

            console.log(this.detail_project)
            
            for (let i = 1; i <= this.detail_project.rab_duration; i++) {
              this.count_week.push(i.toString())
            }
            this.filename = []
            this.form.id = res.results.data.id
            this.form.spk_number = res.results.data.spk_number
            this.form.spk_date = res.results.data.spk_date
            this.form.request_file = Object.keys(res.results.data.spk_file_object).length > 0 ? res.results.data.spk_file_object.doc : []
            this.form.request_image = Object.keys(res.results.data.spk_file_object).length > 0 ? res.results.data.spk_file_object.image : []
            this.form.duration = res.results.data.duration
            this.form.rab_value = res.results.data.rab_value
            this.form.contract_value = res.results.data.contract_value
            this.form.pj_implementation = res.results.data.pj_implementation
            this.form.start_date = res.results.data.start_date === null ||  res.results.data.start_date === '' ? new Date().toISOString().substr(0, 10) : res.results.data.start_date
            let end_date = ''

            end_date = this.detail_project.duration_label === 'hari' ? moment(this.form.start_date).add(((this.detail_project.duration*1)-1), 'days').format('YYYY-MM-DD') : moment(this.form.start_date).add(this.detail_project.duration, 'weeks').format('YYYY-MM-DD')

            this.form.end_date = this.form.end_date === '' || this.form.end_date === null ? new Date(
              end_date
            ).toISOString().substr(0, 10) : this.form.end_date
            // this.form.end_date = res.results.data.end_date === null ||  res.results.data.end_date === '' ? 
            this.form.holiday_array = res.results.data.holiday_array
            // this.filename = res.results.data.spk_file_object.doc.map(item => item.url.split('/').pop())
            this.all_document = []

            if (Object.keys(res.results.data.spk_file_object).length > 0) {
              this.all_document.push(
                ...res.results.data.spk_file_object.image.map(item => {
                  return {
                    title: item.title,
                    url: item.url,
                    type: item.type
                  }
                })
              )
            }
            if (Object.keys(res.results.data.spk_file_object).length > 0) {
              this.all_document.push(
                ...res.results.data.spk_file_object.doc.map(item => {
                  return {
                    title: item.title,
                    url: item.url,
                    type: item.type
                  }
                })
              )
            }
            this.weeks_count = 0
            this.form.start_date = this.form.star_date === '' || this.form.start_date === null ? '' : this.form.start_date
            this.form.end_date = this.form.end_date === '' || this.form.end_date === null ? '' : this.form.end_date
            let start = moment(this.form.start_date),
                end = moment(this.form.end_date),
                day = start.day(),
                days = end.diff(start, 'days') + 1,
                weeks = Math.ceil(days / 7),
                remaining = days % 7,
                count = 0
            this.weeks_count = this.form.star_date !== '' && this.form.end_date !== '' ? weeks : 0
            this.days_count = this.form.star_date !== '' && this.form.end_date !== '' ? days : 0
            this.form.duration = this.form.star_date !== '' && this.form.end_date !== '' ? this.days_count : 0
            this.form.weeks = this.form.star_date !== '' && this.form.end_date !== '' ? this.weeks_count : 0

            console.log(this.form)
          }
        })
      },
      getWeekNumber () {
        this.form.holiday = ''
        this.weeks_count = 0
        let end_date = ''

        end_date = this.detail_project.duration_label === 'hari' ? moment(this.form.start_date).add(((this.detail_project.duration*1)-1), 'days').format('YYYY-MM-DD') : moment(this.form.start_date).add(this.detail_project.duration, 'weeks').format('YYYY-MM-DD')

        this.form.end_date = end_date
        this.form.start_date = this.form.star_date === '' || this.form.start_date === null ? '' : this.form.start_date
        this.form.end_date = this.form.end_date === '' || this.form.end_date === null ? '' : this.form.end_date
        let start = moment(this.form.start_date),
            end = moment(this.form.end_date),
            day = start.day(),
            days = end.diff(start, 'days') + 1,
            weeks = Math.ceil(days / 7),
            remaining = days % 7,
            count = 0
        this.weeks_count = this.form.star_date !== '' && this.form.end_date !== '' ? weeks : 0
        this.days_count = this.form.star_date !== '' && this.form.end_date !== '' ? days : 0
        this.form.duration = this.form.star_date !== '' && this.form.end_date !== '' ? this.days_count : 0
        this.form.weeks = this.form.star_date !== '' && this.form.end_date !== '' ? this.weeks_count : 0
      },

      getWeekNumberEnd () {
        this.form.holiday = ''
        this.weeks_count = 0
        this.form.start_date = this.form.star_date === '' || this.form.start_date === null ? '' : this.form.start_date
        this.form.end_date = this.form.end_date === '' || this.form.end_date === null ? '' : this.form.end_date
        let start = moment(this.form.start_date),
            end = moment(this.form.end_date),
            day = start.day(),
            days = end.diff(start, 'days') + 1,
            weeks = Math.ceil(days / 7),
            remaining = days % 7,
            count = 0
        this.weeks_count = this.form.star_date !== '' && this.form.end_date !== '' ? weeks : 0
        this.days_count = this.form.star_date !== '' && this.form.end_date !== '' ? days : 0
        this.form.duration = this.form.star_date !== '' && this.form.end_date !== '' ? this.days_count : 0
        this.form.weeks = this.form.star_date !== '' && this.form.end_date !== '' ? this.weeks_count : 0
      },

      async save () {
        this.message.error = ''

        this.form.request_file = this.all_document.filter(item => item.type !== 'image')
        this.form.request_image = this.all_document.filter(item => item.type === 'image')

        const isValid = await this.$refs.form.validate(),
              isDocument = this.form.request_file.length > 0 || this.form.request_image.length > 0
        this.message.error = !isValid ? 'Silahkan lengkapi form' : !isDocument ? 'Dokumen Kontrak harus diisi' : ''
        if (isValid && isDocument) {
          this.process.form = true

          // SAVE TO REST API
          await post(`project/pelaksanaan/update`, {
            data: {
              id: this.form.id,
              spk_number: this.form.spk_number,
              spk_date: this.form.spk_date,
              spk_file_object: {
                "doc": this.form.request_file,
                "image": this.form.request_image
              },
              start_date: this.form.start_date,
              end_date: this.form.end_date,
              duration: this.form.duration,
              rab_value: this.form.rab_value,
              contract_value: this.form.contract_value,
              pj_implementation: this.form.pj_implementation,
              holiday_array: this.form.holiday_array
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetch()
              // if (this.form.id === '') {
              // } else {
              //   this.fetch(this.paginationList)
              // }
              this.reset()

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async statuses () {
        this.message.error = ''
        this.process.status = true

        // SAVE TO REST API
        await post(`project/status`, {
          data: {
            id: this.$route.params.id,
            status: this.selected.status
          }
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.dialog.confirm = false
            this.dialog.fullscreen = false
            this.message.success = res.message
            if (this.selected.status === 'Persiapan') {
              this.$router.push(`/project/process/persiapan/${this.form.id}?step=internal`)
            } else {
              this.$router.push(`/project/process/negosiasi/${this.form.id}`)
            }
            this.$emit('reloaddata')

          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper { 
  overflow-y: auto; 
  height: calc(100vh - 250px); 
} 
.wrapper th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>